import { IconButton, SwLogoItem } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import ScrollToTopWrapper from "app/pages/sales-intelligence/common-components/ScrollToTopWrapper/ScrollToTopWrapper";
import { EXTENSION_LINK } from "app/pages/sales-intelligence/constants/common";
import { SIWizardSmallLogoUrl } from "app/pages/sales-intelligence/constants/images";
import downloadExtensionTrackingService from "app/pages/sales-intelligence/services/tracking/download-extension/trackingService";
import { AssetsService } from "app/services/AssetsService";

import {
    StyledCompanyDataBlock,
    StyledDEButtonWrapper,
    StyledDEContentContainer,
    StyledDEContentWrapper,
    StyledDEDescription,
    StyledDEFooterButtonWrapper,
    StyledDEHeaderContainer,
    StyledDEHeaderContainerWrapper,
    StyledDEHeaderProductContainer,
    StyledDEHeaderTitle,
    StyledDownloadExtensionContainer,
    StyledImageContainer,
    StyledItemContainer,
    StyledSalesIntelligenceBlock,
    StyledSITitleText,
    StyledSwLogoItemWrapper,
    StyledTextBlock,
    StyledTextDescriptionBlock,
    StyledTextTitleBlock,
} from "./styles";

const SI_LOGO_SEPARATOR = "%siLogoPlace%";

const DownloadExtensionPageContainer = () => {
    const welcomeTitle = translate("si.onboarding.wizard.welcome-to-text").split(SI_LOGO_SEPARATOR);

    const onClick = (subName: string) => {
        downloadExtensionTrackingService.trackDownloadExtensionAction("download extension page", subName);
    };

    return (
        <ScrollToTopWrapper>
            <StyledDownloadExtensionContainer>
                <StyledDEHeaderContainerWrapper>
                    <StyledDEHeaderContainer>
                        <StyledDEHeaderProductContainer>
                            <StyledSwLogoItemWrapper>
                                <SwLogoItem
                                    isCollapsed={false}
                                    iconName="similar-icon"
                                />
                            </StyledSwLogoItemWrapper>

                            <StyledSalesIntelligenceBlock>
                                <img src={SIWizardSmallLogoUrl} />

                                <StyledSITitleText dangerouslySetInnerHTML={{ __html: welcomeTitle[1] }} />
                            </StyledSalesIntelligenceBlock>
                        </StyledDEHeaderProductContainer>
                        <I18n
                            translatable={{ key: "si.download-extension.header.title" }}
                            element={StyledDEHeaderTitle}
                        />
                        <StyledDEDescription
                            dangerouslySetInnerHTML={{
                                __html: translate("si.download-extension.header.description.sentence1"),
                            }}
                        />

                        <StyledDEDescription
                            dangerouslySetInnerHTML={{
                                __html: translate("si.download-extension.header.description.sentence2"),
                            }}
                        />

                        <StyledDEButtonWrapper>
                            <a
                                target="_blank"
                                href={EXTENSION_LINK}
                                rel="noreferrer"
                                onClick={() => onClick("upper")}
                            >
                                <IconButton
                                    type="primary"
                                    iconName="download"
                                >
                                    {translate("si.common.download-extension")}
                                </IconButton>
                            </a>
                        </StyledDEButtonWrapper>
                    </StyledDEHeaderContainer>
                </StyledDEHeaderContainerWrapper>
                <StyledDEContentWrapper>
                    <StyledDEContentContainer>
                        <StyledItemContainer>
                            <StyledCompanyDataBlock>
                                <I18n
                                    translatable={{ key: "si.download-extension.company-data.title" }}
                                    element={StyledTextTitleBlock}
                                />
                                <StyledTextDescriptionBlock
                                    dangerouslySetInnerHTML={{
                                        __html: translate("si.download-extension.company-data.description"),
                                    }}
                                />
                            </StyledCompanyDataBlock>
                            <StyledImageContainer>
                                <img
                                    src={AssetsService.assetUrl(
                                        "/images/download-extension/company-website-data_no_shadow.png",
                                    )}
                                    alt="Company data"
                                />
                            </StyledImageContainer>
                        </StyledItemContainer>
                        <StyledItemContainer>
                            <StyledImageContainer>
                                <img
                                    src={AssetsService.assetUrl(
                                        "/images/download-extension/traffic-engagement-data.png",
                                    )}
                                    alt="traffic engagement data"
                                />
                            </StyledImageContainer>
                            <StyledTextBlock>
                                <I18n
                                    translatable={{ key: "si.download-extension.traffic-engagement-data.title" }}
                                    element={StyledTextTitleBlock}
                                />
                                <StyledTextDescriptionBlock
                                    dangerouslySetInnerHTML={{
                                        __html: translate("si.download-extension.traffic-engagement-data.description"),
                                    }}
                                />
                            </StyledTextBlock>
                        </StyledItemContainer>
                        <StyledItemContainer>
                            <StyledTextBlock>
                                <I18n
                                    translatable={{ key: "si.download-extension.sam.title" }}
                                    element={StyledTextTitleBlock}
                                />
                                <StyledTextDescriptionBlock
                                    dangerouslySetInnerHTML={{
                                        __html: translate("si.download-extension.sam.description"),
                                    }}
                                />
                            </StyledTextBlock>
                            <StyledImageContainer>
                                <img
                                    src={AssetsService.assetUrl("/images/download-extension/sam.png")}
                                    alt="SAM"
                                />
                            </StyledImageContainer>
                        </StyledItemContainer>
                        <StyledItemContainer>
                            <StyledImageContainer>
                                <img
                                    src={AssetsService.assetUrl("/images/download-extension/contact-data.png")}
                                    alt="Contact data"
                                />
                            </StyledImageContainer>
                            <StyledTextBlock>
                                <I18n
                                    translatable={{ key: "si.download-extension.contact-data.title" }}
                                    element={StyledTextTitleBlock}
                                />
                                <StyledTextDescriptionBlock
                                    dangerouslySetInnerHTML={{
                                        __html: translate("si.download-extension.contact-data.description"),
                                    }}
                                />
                            </StyledTextBlock>
                        </StyledItemContainer>
                        <StyledDEFooterButtonWrapper>
                            <a
                                target="_blank"
                                href={EXTENSION_LINK}
                                rel="noreferrer"
                                onClick={() => onClick("lower")}
                            >
                                <IconButton
                                    type="primary"
                                    iconName="download"
                                >
                                    {translate("si.common.download-extension")}
                                </IconButton>
                            </a>
                        </StyledDEFooterButtonWrapper>
                    </StyledDEContentContainer>
                </StyledDEContentWrapper>
            </StyledDownloadExtensionContainer>
        </ScrollToTopWrapper>
    );
};

export default DownloadExtensionPageContainer;
